<div class="page-content container">
  <div class="page-header"><h1>{{ translationManager.getTranslation('bob_label_6347c5a4d613cb0be0d4f47c') }}</h1></div>
  <div class="page-data shadow-sm">
    <div class="form-blocks">
      <div>
        <div class="content">
          <div class="form-element"><input type="hidden" name="id" [(ngModel)]="form.elements['id'].value"></div>
          <div class="page-part">
            <div class="form-element"
                 [ngClass]="{ 'error': form.elements['requestRoundId'].error.required || form.elements['requestRoundId'].error.invalid }">
              <label>{{translationManager.getTranslation('att_label_6347c814d613cb0be0d4f480')}}</label>
              <div class="content" *ngIf="state === viewState.Create || state === viewState.Edit"><input type="text"
                                                                                                         [(ngModel)]="form.elements['requestRoundId'].value"/>
              </div>
              <div class="content" *ngIf="state === viewState.Details">
                <div class="static"><span>{{ form.elements["requestRoundId"].value | appvalue }}</span></div>
              </div>
              <div class="errors">
                                    <span *ngIf="form.elements['requestRoundId'].error.required">
                                        <i
                                          class="fas fa-times-circle"></i>{{ translationManager.getTranslation('Поље је обавезно за унос') }}</span>
              </div>
            </div>
          </div>
          <div class="page-part">
            <div class="form-element"
                 [ngClass]="{ 'error': form.elements['requestId'].error.required || form.elements['requestId'].error.invalid }">
              <label>{{translationManager.getTranslation('att_label_6347c80dd613cb0be0d4f47f')}}</label>
              <div class="content" *ngIf="state === viewState.Create || state === viewState.Edit"><input type="text"
                                                                                                         [(ngModel)]="form.elements['requestId'].value"/>
              </div>
              <div class="content" *ngIf="state === viewState.Details">
                <div class="static"><span>{{ form.elements["requestId"].value | appvalue }}</span></div>
              </div>
              <div class="errors">
                                    <span *ngIf="form.elements['requestId'].error.required">
                                        <i
                                          class="fas fa-times-circle"></i>{{ translationManager.getTranslation('Поље је обавезно за унос') }}</span>
              </div>
            </div>
          </div>
          <div class="page-part">
            <div class="form-element"
                 [ngClass]="{ 'error': form.elements['requestName'].error.required || form.elements['requestName'].error.invalid }">
              <label>{{translationManager.getTranslation('att_label_6347c821d613cb0be0d4f481')}}</label>
              <div class="content" *ngIf="state === viewState.Create || state === viewState.Edit"><input type="text"
                                                                                                         [(ngModel)]="form.elements['requestName'].value"/>
              </div>
              <div class="content" *ngIf="state === viewState.Details">
                <div class="static"><span>{{ form.elements["requestName"].value | appvalue }}</span></div>
              </div>
            </div>
          </div>
          <div class="page-part">
            <div class="form-element"
                 [ngClass]="{ 'error': form.elements['requestDeadline'].error.required || form.elements['requestDeadline'].error.invalid }">
              <label>{{translationManager.getTranslation('att_label_6347c82cd613cb0be0d4f482')}}</label>
              <div class="content" *ngIf="state === viewState.Create || state === viewState.Edit"><input type="text"
                                                                                                         [(ngModel)]="form.elements['requestDeadline'].value"/>
              </div>
              <div class="content" *ngIf="state === viewState.Details">
                <div class="static"><span>{{ form.elements["requestDeadline"].value | appvalue }}</span></div>
              </div>
            </div>
          </div>
          <div class="page-part">
            <div class="form-element"
                 [ngClass]="{ 'error': form.elements['requestSupplierDeadline'].error.required || form.elements['requestSupplierDeadline'].error.invalid }">
              <label>{{translationManager.getTranslation('att_label_6347c832d613cb0be0d4f483')}}</label>
              <div class="content" *ngIf="state === viewState.Create || state === viewState.Edit"><input type="text"
                                                                                                         [(ngModel)]="form.elements['requestSupplierDeadline'].value"/>
              </div>
              <div class="content" *ngIf="state === viewState.Details">
                <div class="static"><span>{{ form.elements["requestSupplierDeadline"].value | appvalue }}</span></div>
              </div>
            </div>
          </div>

          <div class="page-part" *ngIf="procurementModelUniqueIdentifier === 'AuctionOpen' || procurementModelUniqueIdentifier === 'AuctionSemiOpen' || procurementModelUniqueIdentifier === 'AuctionClosed'">
            <div class="form-element"
                 [ngClass]="{ 'error': form.elements['auctionStartDate'].error.required || form.elements['auctionStartDate'].error.invalid }">
              <label>{{translationManager.getTranslation('Време почетка аукције')}}</label>
              <div class="content" *ngIf="state === viewState.Create || state === viewState.Edit">
                <input type="text"
                       [(ngModel)]="form.elements['auctionStartDate'].value"
                />
              </div>
              <div class="content" *ngIf="state === viewState.Details">
                <div class="static"><span>{{ form.elements["auctionStartDate"].value | appvalue }}</span></div>
              </div>
            </div>
          </div>

          <div class="page-part" *ngIf="procurementModelUniqueIdentifier === 'AuctionOpen' || procurementModelUniqueIdentifier === 'AuctionSemiOpen' || procurementModelUniqueIdentifier === 'AuctionClosed'">
            <div class="form-element"
                 [ngClass]="{ 'error': form.elements['auctionDuration'].error.required || form.elements['auctionDuration'].error.invalid }">
              <label>{{translationManager.getTranslation('Трајање аукције у минутима')}}</label>
              <div class="content" *ngIf="state === viewState.Create || state === viewState.Edit">
                <input type="text"
                       [(ngModel)]="form.elements['auctionDuration'].value"
                />
              </div>
              <div class="content" *ngIf="state === viewState.Details">
                <div class="static"><span>{{ form.elements["auctionDuration"].value | appvalue }}</span></div>
              </div>
            </div>
          </div>

          <div class="page-part">
            <div class="form-element"
                 [ngClass]="{ 'error': form.elements['requestRoundStatusName'].error.required || form.elements['requestRoundStatusName'].error.invalid }">
              <label>{{translationManager.getTranslation('att_label_6347c83bd613cb0be0d4f484')}}</label>
              <div class="content" *ngIf="state === viewState.Create || state === viewState.Edit"><input type="text"
                                                                                                         [(ngModel)]="form.elements['requestRoundStatusName'].value"/>
              </div>
              <div class="content" *ngIf="state === viewState.Details">
                <div class="static"><span>{{ form.elements["requestRoundStatusName"].value | appvalue }}</span></div>
              </div>
            </div>
          </div>
          <translation-entity *ngIf="translationEntityDisplay" #translationEntitySupplierRoundListViewName
                              [uniqueIdentifier]="'SupplierRoundListView-Name'"></translation-entity>
          <div class="form-element-buttons">
            <button class="btn btn-warning fl" (click)="navigateToList()">
              <i class="fa fa-arrow-left mr-2"></i>{{ translationManager.getTranslation('Назад') }}</button>
            <button class="btn btn-success fr" (click)="submit()"
                    *ngIf="state === viewState.Create || state === viewState.Edit">
              <i class="fa fa-check mr-2"></i>{{ translationManager.getTranslation('Сачувај') }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
